var _defs, _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 428.51,
    viewBox: "0 0 500 428.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebebeb;}.cls-2{fill:#c7c7c7;}.cls-3{fill:#dbdbdb;}.cls-4{fill:#fff;}.cls-5{fill:#263238;}.cls-6{fill:#eb9481;}.cls-7{fill:#289ff3;}.cls-8{fill:#37474f;}.cls-9{fill:#a6a6a6;}.cls-10{fill:#ff99ba;}.cls-11{isolation:isolate;}.cls-11,.cls-12{opacity:0.2;}.cls-13{fill:#ad6359;}.cls-14{fill:#455a64;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "213.91 279.75 212.99 285.39 212.01 291.44 203 346.68 188.27 346.68 197.27 291.44 198.26 285.39 199.19 279.75 213.91 279.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.78,315.5c-.78,5.59-1.61,11.18-2.45,16.75L206.72,349,204,365.72l-1.4,8.35-1.46,8.35,1.2-8.39,1.25-8.38,2.63-16.74L209,332.19Q210.29,323.84,211.78,315.5Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "212.99 285.39 212.01 291.44 197.27 291.44 198.26 285.39 212.99 285.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "286.63 279.75 287.55 285.39 288.53 291.44 297.54 346.68 312.27 346.68 303.27 291.44 302.28 285.39 301.36 279.75 286.63 279.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.81,315.5c.77,5.59,1.61,11.18,2.45,16.75l2.6,16.75,2.72,16.72,1.41,8.35,1.46,8.35-1.2-8.39L297,365.65l-2.6-16.74-2.73-16.72C290.74,326.62,289.8,321.05,288.81,315.5Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "287.55 285.39 302.28 285.39 303.27 291.44 288.53 291.44 287.55 285.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "213.37 264.22 201.7 264.22 203.15 253.32 211.92 253.32 213.37 264.22"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 207.54,
    cy: 245.56,
    r: 10.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 207.53,
    cy: 281.29,
    r: 8.28,
    transform: "translate(-114.03 382.64) rotate(-76.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.45,280.81a7.17,7.17,0,0,0-2.7-5.08,7.32,7.32,0,0,0-5.57-1.45,7,7,0,0,0-4.78,3.1,7.33,7.33,0,0,0-.87,6,6.87,6.87,0,0,0,3.23,4.1,7.23,7.23,0,0,0,5.07.78,7.49,7.49,0,0,0,4.24-2.61,7.87,7.87,0,0,0,1.75-4.61c0-.07,0-.14-.07-.14s-.07.06-.07.14a7.62,7.62,0,0,1-.39,2,8.45,8.45,0,0,1-.91,1.8,8,8,0,0,1-1.36,1.48,8.4,8.4,0,0,1-1.71,1.12,7,7,0,0,1-5.66.14,6.81,6.81,0,0,1-3.82-4.21,7,7,0,0,1,.72-5.79,6.7,6.7,0,0,1,4.65-3.07,7.24,7.24,0,0,1,6.86,2.73A7.56,7.56,0,0,1,214,279a8.37,8.37,0,0,1,.44,1.92h0A.3.3,0,0,0,214.45,280.81Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.48,280.82a6.16,6.16,0,0,0-2.34-4.34,6.39,6.39,0,0,0-4.76-1.26,6,6,0,0,0-4.13,2.65,6.31,6.31,0,0,0-.8,5.16,5.87,5.87,0,0,0,2.8,3.57,6.14,6.14,0,0,0,4.42.67,6.52,6.52,0,0,0,3.67-2.28,6.81,6.81,0,0,0,1.51-4c0-.06,0-.12-.06-.12s-.08.05-.08.12a6.58,6.58,0,0,1-3.78,5.51,5.92,5.92,0,0,1-4.89.14,5.82,5.82,0,0,1-3.3-3.64,6,6,0,0,1,.66-5,5.69,5.69,0,0,1,4-2.59A6,6,0,0,1,213,279.2a7.68,7.68,0,0,1,.39,1.64h0Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.51,280.83a5.26,5.26,0,0,0-2-3.6,5.47,5.47,0,0,0-3.95-1.06,5,5,0,0,0-3.49,2.17,5.32,5.32,0,0,0-.73,4.37,4.93,4.93,0,0,0,2.37,3.06,5.24,5.24,0,0,0,3.78.54,5.42,5.42,0,0,0,3.1-2,6,6,0,0,0,1.28-3.37c0-.06,0-.11-.07-.11a.08.08,0,0,0-.08.1h0a5.65,5.65,0,0,1-3.18,4.64,5,5,0,0,1-4.13.14,4.83,4.83,0,0,1-2.79-3.08,5.07,5.07,0,0,1,.6-4.19,4.78,4.78,0,0,1,3.37-2.11,5.92,5.92,0,0,1,2.67.31,5.08,5.08,0,0,1,2.17,1.61,4.89,4.89,0,0,1,.68,1.2,6.32,6.32,0,0,1,.35,1.36h0Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.55,280.84a4.34,4.34,0,0,0-1.63-2.85,4.47,4.47,0,0,0-3.14-.87,4.1,4.1,0,0,0-2.85,1.7,4.35,4.35,0,0,0-.66,3.57,4,4,0,0,0,1.95,2.54,4.35,4.35,0,0,0,3.12.43,4.56,4.56,0,0,0,2.54-1.64,5,5,0,0,0,1-2.76.08.08,0,0,0-.07-.09h0a.08.08,0,0,0-.08.08,4.66,4.66,0,0,1-2.5,3.79,4,4,0,0,1-3.37.16,3.91,3.91,0,0,1-2.27-2.54,4.08,4.08,0,0,1,.54-3.38,3.83,3.83,0,0,1,2.72-1.64,4.89,4.89,0,0,1,2.11.28,4.08,4.08,0,0,1,1.73,1.23,4.71,4.71,0,0,1,.55.95,5.68,5.68,0,0,1,.31,1.09h0Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "298.59 264.22 286.91 264.22 288.36 253.32 297.14 253.32 298.59 264.22"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 292.92,
    cy: 244.87,
    r: 10.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 292.74,
    cy: 245.54,
    r: 8.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.67,280.81a7.23,7.23,0,0,0-2.7-5.08,7.32,7.32,0,0,0-5.57-1.45,7,7,0,0,0-4.78,3.1,7.29,7.29,0,0,0-.87,6,6.83,6.83,0,0,0,3.23,4.1,7.23,7.23,0,0,0,5.07.78,7.46,7.46,0,0,0,4.24-2.61,7.87,7.87,0,0,0,1.75-4.61c0-.07,0-.14-.07-.14s-.07.06-.08.14a7.61,7.61,0,0,1-.38,2,8,8,0,0,1-.92,1.8,7.89,7.89,0,0,1-3.07,2.6,7,7,0,0,1-5.65.14,6.8,6.8,0,0,1-3.83-4.21,7,7,0,0,1,.73-5.79,6.72,6.72,0,0,1,4.65-3.07,7.24,7.24,0,0,1,6.86,2.73,7.77,7.77,0,0,1,.92,1.73,7.86,7.86,0,0,1,.43,1.92h0A.26.26,0,0,0,299.67,280.81Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.7,280.82a6.25,6.25,0,0,0-2.34-4.34,6.39,6.39,0,0,0-4.76-1.26,6,6,0,0,0-4.14,2.65,6.31,6.31,0,0,0-.8,5.16,5.87,5.87,0,0,0,2.8,3.57,6.19,6.19,0,0,0,4.42.67,6.46,6.46,0,0,0,3.68-2.28,6.88,6.88,0,0,0,1.51-4c0-.06,0-.12-.07-.12s-.07.05-.08.12a6.55,6.55,0,0,1-3.77,5.51,5.92,5.92,0,0,1-4.89.14A5.81,5.81,0,0,1,287,283a6,6,0,0,1,.66-5,5.73,5.73,0,0,1,4-2.59,6.21,6.21,0,0,1,5.85,2.33,6.09,6.09,0,0,1,.8,1.46,6.64,6.64,0,0,1,.39,1.64h0Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.73,280.83a5.3,5.3,0,0,0-2-3.6,5.46,5.46,0,0,0-3.94-1.06,5,5,0,0,0-3.48,2.17,5.4,5.4,0,0,0-.74,4.37,5,5,0,0,0,2.38,3.06,5.27,5.27,0,0,0,3.77.54,5.41,5.41,0,0,0,3.11-2,5.83,5.83,0,0,0,1.27-3.37c0-.06,0-.11-.06-.11a.09.09,0,0,0-.08.1h0a5.65,5.65,0,0,1-3.18,4.64,5,5,0,0,1-4.13.14,4.83,4.83,0,0,1-2.79-3.08,5.07,5.07,0,0,1,.6-4.19,4.76,4.76,0,0,1,3.37-2.11,5.92,5.92,0,0,1,2.67.31,5,5,0,0,1,2.17,1.61,4.89,4.89,0,0,1,.68,1.2,7,7,0,0,1,.35,1.36h0Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.76,280.84a4.24,4.24,0,0,0-1.62-2.85,4.46,4.46,0,0,0-3.13-.87,4,4,0,0,0-2.86,1.7,4.43,4.43,0,0,0-.66,3.57,4,4,0,0,0,1.95,2.54,4.35,4.35,0,0,0,3.12.43,4.56,4.56,0,0,0,2.54-1.64,5,5,0,0,0,1-2.76.07.07,0,0,0-.05-.09h0a.08.08,0,0,0-.08.08,4.66,4.66,0,0,1-2.59,3.76,4,4,0,0,1-3.36.16,3.91,3.91,0,0,1-2.27-2.54,4.08,4.08,0,0,1,.54-3.38,3.8,3.8,0,0,1,2.73-1.64,4.82,4.82,0,0,1,2.09.28,3.94,3.94,0,0,1,1.73,1.23,4.32,4.32,0,0,1,.56.95,5,5,0,0,1,.31,1.09h0S296.77,280.85,296.76,280.84Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 176.88,
    y: 258.67,
    width: 146.77,
    height: 28.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "207.05 258.67 196.4 286.74 177.44 286.74 188.09 258.67 207.05 258.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.91 258.67 235.25 286.74 216.29 286.74 226.94 258.67 245.91 258.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "284.75 258.67 274.11 286.74 255.15 286.74 265.8 258.67 284.75 258.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "323.61 258.67 312.96 286.74 294 286.74 304.65 258.67 323.61 258.67"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 179.85,
    y: 312.7,
    width: 140.83,
    height: 17.77
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "208.8 312.7 198.58 330.46 180.4 330.46 190.62 312.7 208.8 312.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "246.09 312.7 235.87 330.46 217.66 330.46 227.89 312.7 246.09 312.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "283.36 312.7 273.13 330.46 254.94 330.46 265.17 312.7 283.36 312.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "320.64 312.7 310.42 330.46 292.23 330.46 302.45 312.7 320.64 312.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M468.31,160.72H355S366.24,130,383.52,130s22.71,21.17,22.71,21.17,11.66-11.5,21.25-11.5,17.91,15.2,17.91,15.2S458.94,146.73,468.31,160.72Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.65,88.75H111.7s11.82-17.14,21.15-17.14S144.93,83,144.93,83s6.57-5.33,12.67-4.38S164.65,88.75,164.65,88.75Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M450.27,212.17H397.32S409.15,195,418.47,195s12.08,11.42,12.08,11.42,6.57-5.34,12.67-4.38S450.27,212.17,450.27,212.17Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.38,131.71H32.23S46.36,100.17,61.47,98.2,83.8,121.63,83.8,121.63s9.75-9,17.41-9,13.57,11.82,13.57,11.82S130.14,116.37,135.38,131.71Z",
    transform: "translate(0 -35.74)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "35.95 346.93 89.03 346.69 142.11 346.6 248.27 346.43 354.43 346.6 407.51 346.69 460.59 346.93 407.51 347.17 354.43 347.26 248.27 347.43 142.11 347.26 89.03 347.17 35.95 346.93"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-19"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 250.27,
    cy: 401.3,
    rx: 210.32,
    ry: 24.52
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M277.77,441.62c2.08.7,61.69.91,64-.52.87-.54,1.4-9.22,1.75-19.72.08-2.27.14-4.61.2-7l4.83-31.78-39.85-.26-3.76,31.8.15,7s-22.86,10.13-25.19,12S275.7,440.91,277.77,441.62Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M277.77,441.62c2.08.7,61.69.91,64-.52,1.05-.66,1.63-13.33,1.95-26.72l-38.78-.24.15,7s-22.86,10.13-25.19,12S275.7,440.91,277.77,441.62Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M277.77,441.62c2.08.7,61.69.91,64-.52.87-.54,1.4-9.22,1.75-19.72l-38.43-.25s-22.86,10.13-25.19,12S275.7,440.91,277.77,441.62Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M278.64,439.24c10-.21,50.32-.12,60.21.43.08,0,.08.06,0,.07-9.9.42-50.23,0-60.22-.34C278.42,439.39,278.43,439.24,278.64,439.24Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M283.72,431a8,8,0,0,1,6,2.46,7.83,7.83,0,0,1,2.23,5.35c0,.06-.12.06-.13,0a9.28,9.28,0,0,0-8-7.68.07.07,0,0,1-.11,0A.07.07,0,0,1,283.72,431Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M301.19,422.11c4,0,8.62,1.39,11.1,4.67.1.13-.08.26-.2.2a56.16,56.16,0,0,0-11-4.38.25.25,0,0,1-.2-.3A.27.27,0,0,1,301.19,422.11Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M298.09,423.3c4,0,8.63,1.39,11.1,4.68.1.12-.08.26-.2.19a55,55,0,0,0-11-4.37.26.26,0,0,1,.11-.5Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M295,424.5c4-.05,8.63,1.39,11.11,4.67.09.12-.09.26-.21.2a54.48,54.48,0,0,0-11-4.38.25.25,0,0,1-.19-.3A.25.25,0,0,1,295,424.5Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M291.91,425.7c4,0,8.63,1.38,11.11,4.66.09.12-.09.26-.21.2a54.68,54.68,0,0,0-11-4.37.26.26,0,0,1-.2-.3.25.25,0,0,1,.31-.19Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M336.36,430.17c4.5,0,4.46,7,0,7S331.84,430.14,336.36,430.17Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M297.2,417.29c2.14,2.79,5.43,4.56,8.27,6.53a.49.49,0,0,0,.67-.18.58.58,0,0,0,.05-.14.1.1,0,0,0,.12-.07v0a21,21,0,0,0-3.59-10.24c-1.24-1.75-3.79-3.39-5.82-1.72S295.94,415.66,297.2,417.29ZM297,414c.42-4.34,4.34-1,5.2.33a24.24,24.24,0,0,1,1.45,2.71,63.2,63.2,0,0,1,2.23,5.93c-1.33-1.06-2.75-2-4.12-3C300.14,418.75,296.8,416.38,297,414Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M320.53,420.89c-.3-2.61-3.29-3.18-5.39-2.79a21.1,21.1,0,0,0-9.69,4.88.1.1,0,0,0,0,.14l0,0a.49.49,0,0,0,.14.67.39.39,0,0,0,.15.06c3.42.54,7,1.55,10.5,1C318.28,424.6,320.82,423.36,320.53,420.89Zm-9.42,2.75c-1.7-.22-3.36-.53-5-.69a55.46,55.46,0,0,1,5.72-2.73,23.09,23.09,0,0,1,2.92-.94c1.54-.35,6.69-.06,4,3.36C317.17,424.52,313.12,423.89,311.11,423.64Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M407.08,235.63s-46.28,78.72-47.52,84.25c-1.9,8.5-12,92.37-12,92.37l-48.16-.86s8.3-74,16.16-98.32c5.67-17.55,46.5-75.75,46.5-75.75Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M303.79,404c6.92-.05,31.42-.32,40.62.53a.07.07,0,0,1,0,.14h0c-3.16.45-33.7-.26-40.62-.48a.1.1,0,1,1-.07-.19Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M399.18,242.86c-3,4.75-6.24,9.41-9.34,14.12s-6.19,9.44-9.24,14.2q-9.14,14.24-17.86,28.73a89.19,89.19,0,0,0-7.22,14,86.85,86.85,0,0,0-4,15.11c-1,5.18-1.57,10.39-2.15,15.61q-.94,8.33-1.86,16.66-1.9,17-3.81,34.09c-.16,1.39-.31,2.8-.45,4.19a.19.19,0,0,0,.37,0c1.41-11.3,2.59-22.62,3.89-33.93l1.92-16.84c.59-5.23,1.16-10.47,2-15.68A104.74,104.74,0,0,1,354.77,318a72.42,72.42,0,0,1,6.62-14.73c5.58-9.62,11.48-19.08,17.39-28.51s12-19,18.2-28.36c.76-1.15,1.54-2.3,2.34-3.43C399.43,242.85,399.24,242.77,399.18,242.86Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M366.17,448.24c2.19.14,61.33-15.45,63.17-17.41a.84.84,0,0,0,.14-.4c.23-1.94-2.79-9.2-4.91-18.5-.13-.59-1.24-3.41-2.8-7.23-4.3-10.46-12-28.44-12-28.44l-38.61,9.91,14.22,28.58,1.92,6.72s-19.53,15.63-21.31,18S364,448.08,366.17,448.24Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.17,448.24c2.19.14,61.33-15.45,63.17-17.41a.84.84,0,0,0,.14-.4c.23-1.94-2.79-9.2-4.91-18.5-.13-.59-1.24-3.41-2.8-7.23l-36.34,10,1.92,6.72s-19.53,15.63-21.31,18S364,448.08,366.17,448.24Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M366.17,448.23c2.19.16,61.33-15.44,63.17-17.4.7-.74-.83-8.74-4.77-18.9l-37.22,9.55s-19.53,15.61-21.31,18S364,448.08,366.17,448.23Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M366.4,445.71C376,443,415,432.79,424.74,430.8c.08,0,.09,0,0,.07-9.46,2.92-48.56,12.78-58.31,15C366.24,445.92,366.2,445.77,366.4,445.71Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M369.21,436.42a8,8,0,0,1,6.4.86,7.85,7.85,0,0,1,3.5,4.6.06.06,0,0,1-.12,0,9.26,9.26,0,0,0-9.75-5.37.06.06,0,0,1-.08,0,.05.05,0,0,1,0-.08A.06.06,0,0,1,369.21,436.42Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M383.84,423.41c3.86-1.06,8.7-.86,11.93,1.68.13.1,0,.28-.14.25a55.86,55.86,0,0,0-11.73-1.45.24.24,0,0,1-.21-.28A.26.26,0,0,1,383.84,423.41Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M381.16,425.35c3.86-1.06,8.7-.86,11.92,1.69.13.1,0,.28-.15.25a54.34,54.34,0,0,0-11.72-1.39.28.28,0,0,1,0-.55Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M378.47,427.3c3.86-1.06,8.7-.86,11.93,1.68.12.1,0,.27-.15.25a54.39,54.39,0,0,0-11.72-1.44.25.25,0,0,1-.06-.49Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M375.79,429.23c3.85-1.05,8.7-.85,11.92,1.69.13.1,0,.27-.14.24a55.82,55.82,0,0,0-11.72-1.43.24.24,0,0,1-.28-.22A.25.25,0,0,1,375.79,429.23Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M419.89,422.26c4.35-1.12,6.09,5.64,1.74,6.75S415.54,423.37,419.89,422.26Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M378.76,419.76c2.79,2.15,6.42,3,9.66,4.21a.48.48,0,0,0,.6-.34.39.39,0,0,0,0-.15.09.09,0,0,0,.1-.1.06.06,0,0,0,0,0,21,21,0,0,0-6.09-9c-1.64-1.37-4.52-2.32-6.06-.18S377.14,418.51,378.76,419.76Zm-1-3.15c-.7-4.32,3.93-2.07,5.1-1a22.37,22.37,0,0,1,2.1,2.25,60.24,60.24,0,0,1,3.67,5.16c-1.56-.68-3.17-1.22-4.76-1.85-1.9-.74-5.73-2.18-6.12-4.55Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M402.23,417.31c-1-2.46-4-2.25-5.91-1.33a20.89,20.89,0,0,0-8.13,7.19.1.1,0,0,0,0,.14l0,0a.48.48,0,0,0,.33.61.32.32,0,0,0,.14,0c3.45-.35,7.18-.29,10.41-1.68C401,421.47,403.15,419.62,402.23,417.31Zm-8.4,5.06c-1.69.21-3.38.34-5,.61a63,63,0,0,1,4.84-4.09,21.71,21.71,0,0,1,2.58-1.65c1.4-.74,6.45-1.77,4.69,2.23C399.92,421.68,395.85,422.12,393.83,422.37Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M382.77,412.88,426,401.53S384.62,320,385,314.38c.3-5,30.34-48.73,32-56.92,2.71-13.4-3.81-25.37-10.14-32.78l-44.75,12.61s3.56,7.74,10.11,12.63c0,0-28.12,47-28.84,62.4S382.77,412.88,382.77,412.88Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M382,404.87c6.27-1.79,4.45-1.36,10.74-3.09,3.09-.84,23.34-6.38,26.34-6.67.07,0,.1.1,0,.13-2.76,1.24-23.1,6.43-26.2,7.21-6.32,1.6-4.53,1.07-10.88,2.61C381.88,405.07,381.83,404.87,382,404.87Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M365.31,248.14A80.08,80.08,0,0,1,377.7,254a.14.14,0,0,1,.06.18.14.14,0,0,1-.18.06h0c-4.18-1.82-8.44-3.56-12.51-5.61a.27.27,0,0,1-.08-.37A.28.28,0,0,1,365.31,248.14Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M370.57,247a18.9,18.9,0,0,1,.8,2.41,5.13,5.13,0,0,1,.31,2,.15.15,0,0,1-.2,0,.1.1,0,0,1-.06,0,7.13,7.13,0,0,1-.84-1.94c-.27-.75-.56-1.49-.8-2.24C369.61,246.8,370.4,246.56,370.57,247Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M370.57,243c-.18-.69-.36-1.37-.55-2.06s-.45-1.41-.59-2.13c0-.11-.2-.06-.17,0,.17.69.25,1.41.37,2.12s.26,1.4.4,2.09a36.79,36.79,0,0,0,1,3.88,4.71,4.71,0,0,1-2-.61,3.62,3.62,0,0,1-1.22-1.91c-.28-.78-.53-1.57-.82-2.34a16.06,16.06,0,0,1-.86-2.62c0-.12-.2-.07-.18,0a27.88,27.88,0,0,0,1.59,5.52c.31.7.54,1.42,1.23,1.76a6,6,0,0,0,2.4.47c.09,0,.23,0,.21-.13C371.17,245.75,370.91,244.34,370.57,243Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M371.31,251.48c-1.7,3.07-3.64,6-5.46,9s-3.47,5.92-5.13,8.93c-3.34,6.06-6.45,12.29-9.28,18.62q-2.1,4.69-4,9.5a71.39,71.39,0,0,0-3.26,9.81,27.09,27.09,0,0,0-.44,10.19,69.58,69.58,0,0,0,2.68,10.25,182.54,182.54,0,0,0,8.45,22.44c.11.24.51.06.42-.19-2.36-6.66-4.8-13.31-6.93-20-2.06-6.55-4.5-13.33-3.37-20.29a52.49,52.49,0,0,1,2.85-9.76q1.82-4.86,3.88-9.62c2.72-6.26,5.77-12.33,8.89-18.39,1.74-3.39,3.57-6.75,5.35-10.13s3.51-6.89,5.5-10.17C371.52,251.47,371.4,251.39,371.31,251.48Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M403.9,244.91c-.81-.13-2,.15-5.5-.09a20.1,20.1,0,0,1-2.88-.47,6.41,6.41,0,0,1-2.68-1.08,14.29,14.29,0,0,1-3-4.21,21.1,21.1,0,0,1-2.13-5.18c0-.11-.19-.06-.17.05.19,1,.29,2,.56,3.06a18.05,18.05,0,0,0,1,2.78,11.38,11.38,0,0,0,3.13,4.63c1.59,1.19,3.8,1.41,5.71,1.55,1.11.08,5.47,0,6-.66C404.06,245.18,404.05,244.94,403.9,244.91Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M415.3,392.22q-8.19-16.64-16-33.49t-15.2-33.94a45.07,45.07,0,0,1-3.23-8.38c-.67-3.18.31-6,1.65-8.88a153.12,153.12,0,0,1,8.36-15.17c3-4.92,6.25-9.74,9.42-14.57a152,152,0,0,0,9-14.74c2.46-4.92,3.84-10.15,3.14-15.66s-3.08-10.59-5.61-15.42c-.67-1.28-1.36-2.54-2-3.82-.05-.09-.2,0-.14.09,2.82,5.07,5.53,10.38,6.85,16a26.14,26.14,0,0,1,.63,8.59,27.34,27.34,0,0,1-2.43,8.38c-2.35,5.16-5.63,9.93-8.73,14.66s-6.38,9.66-9.47,14.57a169.49,169.49,0,0,0-8.62,15.19c-1.14,2.33-2.39,4.76-2.67,7.37-.3,2.88.73,5.62,1.84,8.21,4.81,11.27,9.87,22.46,15,33.58s10.48,22.28,15.9,33.33l2,4.18C415.13,392.55,415.38,392.39,415.3,392.22Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M361.15,141.19c1-4.58,6.09-14.93,16.13-12.91,14.33,2.9,16.41,30.52,23.54,39.13,12.93,15.59,13.35,31,2.76,33.5-11.88,2.77-23.43-10-23-37.54.27-17.24-4.58-24.88-8-24.36s-5.31,4.86-5.31,4.86Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M361.63,139.48a27.72,27.72,0,0,1,2.87-6.08,16.58,16.58,0,0,1,4.69-4.93,11.23,11.23,0,0,1,6.63-1.92,14.5,14.5,0,0,1,6.65,1.85,16.07,16.07,0,0,1,5,4.7,29.66,29.66,0,0,1,3.21,6,60.2,60.2,0,0,1,3.33,13,90.08,90.08,0,0,0-4.23-12.6,31.71,31.71,0,0,0-3.27-5.68,15.13,15.13,0,0,0-4.71-4.3,13.5,13.5,0,0,0-6.07-1.76,10.43,10.43,0,0,0-6,1.57,16.92,16.92,0,0,0-4.72,4.44,30,30,0,0,0-1.83,2.76A31.19,31.19,0,0,0,361.63,139.48Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M380.5,153.87c.15,2.73,0,5.48-.06,8.21s-.17,5.46-.18,8.18a75.9,75.9,0,0,0,.36,8.13,41.84,41.84,0,0,0,1.46,7.92,21,21,0,0,0,3.5,7.1,22.81,22.81,0,0,0,6,5.2,17.09,17.09,0,0,0,7.56,2.42,15,15,0,0,0,4-.21,14.35,14.35,0,0,0,2-.52,7,7,0,0,0,1.84-.85,10.17,10.17,0,0,1-3.73,1.69,15.93,15.93,0,0,1-4.12.51,16.55,16.55,0,0,1-4.14-.59,18.2,18.2,0,0,1-3.88-1.59,20.92,20.92,0,0,1-3.46-2.36l-.79-.68-.76-.71a15.12,15.12,0,0,1-1.44-1.56,22.13,22.13,0,0,1-3.77-7.49,52.6,52.6,0,0,1-1.58-16.43c.08-2.74.29-5.48.53-8.2S380.41,156.6,380.5,153.87Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M360.33,141.27c-.16-1.27.61-3,1.41-3.32s7.19,1.75,7.86,3.28-1.91,3.16-1.91,3.16Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M368,186.36c-3.94,5.61-32.39,28.85-47.9,29.71-7,.38-34.42-2.6-40.53-5.12-7.5-3.08,7.33-21.65,12-20.86,5.87,1,26.67,3.19,30.82,3.3,6.65.17,27-11,40.75-13.92C370.23,178,371,182,368,186.36Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M367.67,187.42C363.32,195,348,208,348,208l-2.62-4.83-8.65-15.92s14.54-5.79,24.18-8.6a21.58,21.58,0,0,1,3.46-.76C370.59,177.08,371.4,180.91,367.67,187.42Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M367.67,187.42C363.32,195,348,208,348,208l-2.62-4.83-1.78-3.28-6.88-12.63s14.55-5.81,24.19-8.62a22.69,22.69,0,0,1,3.46-.75h.37C370.62,177.24,371.34,181,367.67,187.42Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M349.54,183.32a9.08,9.08,0,0,1,0,4.21A8.82,8.82,0,0,1,349.54,183.32Zm-4.12,8.25a8.19,8.19,0,0,0-2.09.25,7.77,7.77,0,0,0,2.09.25,8.34,8.34,0,0,0,2.11-.25,8.34,8.34,0,0,0-2.11-.25Zm21.27-11.75a7.91,7.91,0,0,0-2.11.25,7.91,7.91,0,0,0,2.11.25,8.24,8.24,0,0,0,2.09-.25A8.24,8.24,0,0,0,366.69,179.82Zm-8.19,10.45a8.08,8.08,0,0,0,1.66,1.3,8.36,8.36,0,0,0-1.3-1.66,8.65,8.65,0,0,0-1.66-1.3,8.36,8.36,0,0,0,1.3,1.66Zm-8.08,10a7.8,7.8,0,0,0,1.66,1.31,7.75,7.75,0,0,0-1.3-1.66,8.05,8.05,0,0,0-1.66-1.31,7.58,7.58,0,0,0,1.26,1.66Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M350.66,204.44c-1.45-2.94-7.86-14.75-9.41-17.21-.11-.17-.24-.15-.16,0a183.1,183.1,0,0,0,9.45,17.21C350.58,204.56,350.7,204.52,350.66,204.44Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M367.67,187.42C363.32,195,348,208,348,208l-2.62-4.83-1.78-3.28c8.32-8.21,18.34-18.31,21.14-22C370.62,177.24,371.34,181,367.67,187.42Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.48,222.33l2.27,25a84.44,84.44,0,0,0,9.14-.92,214.81,214.81,0,0,0,23.7-4.93c7.74-2,16.81-4.77,27.18-8.45,0,0-23.46-42.31-39.64-54-.37-.27-.73-.52-1.1-.75l-.22-.14c-7.35-4.66-14-1-17.69,4.18-.94,1.3-9.95,21.79-9.49,28.65C348,217.05,353.48,222.33,353.48,222.33Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.5,195.54a8.14,8.14,0,0,1,.25,2.09,8.27,8.27,0,0,1-.25,2.1,7.46,7.46,0,0,1-.25-2.1A7.72,7.72,0,0,1,366.5,195.54Zm5.45,26.2a8.82,8.82,0,0,0,.25,2.11,7.53,7.53,0,0,0,.25-2.11,7.89,7.89,0,0,0-.25-2.1,8.8,8.8,0,0,0-.25,2.1Zm17.47-14.91a7.84,7.84,0,0,0,.25,2.1,9,9,0,0,0,0-4.2A7.79,7.79,0,0,0,389.42,206.83Zm-32,11.72a7.79,7.79,0,0,0,.25,2.1,9,9,0,0,0,0-4.2A7.84,7.84,0,0,0,357.39,218.55Zm20.18-18.45a8.68,8.68,0,0,0-2.1.25,8.77,8.77,0,0,0,4.2,0,8.66,8.66,0,0,0-2.09-.25Zm14.89,18.67a7.84,7.84,0,0,0-2.1.25,8.82,8.82,0,0,0,4.21,0,8.27,8.27,0,0,0-2.1-.25Zm-22.64,14.8a7.72,7.72,0,0,0-2.09.25,7.72,7.72,0,0,0,2.09.25,8.21,8.21,0,0,0,2.1-.25,8.19,8.19,0,0,0-2.09-.25Zm26.38-2.89a8.6,8.6,0,0,0-2.09.25,8.73,8.73,0,0,0,4.19,0A8.74,8.74,0,0,0,396.2,230.68Zm-29.51-50.89a7.91,7.91,0,0,0-2.11.25,7.91,7.91,0,0,0,2.11.25,8.24,8.24,0,0,0,2.09-.25,8.21,8.21,0,0,0-2.09-.22Zm10.71,4.63a8.17,8.17,0,0,0,1.66,1.32,7.28,7.28,0,0,0-1.3-1.67,9.12,9.12,0,0,0-1.66-1.31,8,8,0,0,0,1.31,1.69Zm21.87,23.42a8.05,8.05,0,0,0,1.66,1.31,7.45,7.45,0,0,0-1.3-1.66,8.05,8.05,0,0,0-1.66-1.31,8.26,8.26,0,0,0,1.3,1.69Zm-35,2.5a8.11,8.11,0,0,0,1.67,1.31,9.09,9.09,0,0,0-3-3,8.29,8.29,0,0,0,1.34,1.72Zm20.13,16.95a7.8,7.8,0,0,0,1.66,1.31,9.09,9.09,0,0,0-3-3A8.15,8.15,0,0,0,384.42,227.29Zm-25.87-37a8.08,8.08,0,0,0,1.66,1.3,8.36,8.36,0,0,0-1.3-1.66,8.65,8.65,0,0,0-1.66-1.3,8.15,8.15,0,0,0,1.25,1.68Zm-1.42,13.16a8.86,8.86,0,0,0,1.31-1.67,8.08,8.08,0,0,0-1.66,1.3,8.52,8.52,0,0,0-1.32,1.67,8.7,8.7,0,0,0,1.62-1.28Zm47.5,17.87a8.08,8.08,0,0,0,1.3-1.66,8.91,8.91,0,0,0-3,3,8.44,8.44,0,0,0,1.65-1.33Zm-44.91,7.17a8.08,8.08,0,0,0,1.3-1.66,8.79,8.79,0,0,0-3,3,8,8,0,0,0,1.65-1.32Zm26.81-34.51a8.12,8.12,0,0,0,1.31-1.66,8.94,8.94,0,0,0-3,3,8.05,8.05,0,0,0,1.61-1.3Zm-6.65,44.95a7.8,7.8,0,0,0,1.31-1.66,7.8,7.8,0,0,0-1.66,1.31,8.33,8.33,0,0,0-1.31,1.66,8,8,0,0,0,1.61-1.29Zm0-27a7.8,7.8,0,0,0,1.31-1.66,9.09,9.09,0,0,0-3,3,8,8,0,0,0,1.66-1.36Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M370.22,177.75c-.14,1-4.12,7.51-8.47,7.68-1.42,0-2.05-7.66-2.05-7.66l-.18-.56-2.47-7.82,8.85-6.78,1.29-.91s.53,2.19,1.17,4.92l.09.39a2.36,2.36,0,0,0,.11.44l.3,1.23c.07.32.14.63.2,1l.21,1A52.44,52.44,0,0,1,370.22,177.75Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M368.4,166.62a16.46,16.46,0,0,1-8.84,10.64l-2.47-7.82,8.81-6.83,1.29-.91S367.72,163.84,368.4,166.62Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M346.07,157.61c-.07,14.39,8.55,16.06,11.66,16.07,2.81,0,12.41-.31,14-14.62s-5.11-18.89-11.55-19.26S346.14,143.18,346.07,157.61Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M370.91,160c-2.35.24-3-4.7-3-4.7s-4.8.14-6.55-6.72a10.64,10.64,0,0,0,2.26,5.65s-8.5-.66-12.24-7.67c0,0,1.51,3.58,2.87,4.83a10,10,0,0,1-5.37-3.75s-1.38,4.13-2.5,5.28c0,0-1.64-7.25,1.38-11,6.34-8,16.76-1,16.76-1s5.83.88,7.91,5.24C375.65,152.86,370.91,160,370.91,160Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M369.4,160.12s2.76-4.74,4.89-3.79.3,7.64-2,8.72a2.43,2.43,0,0,1-3.31-.92.3.3,0,0,1,0-.08Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M373.72,158.31a6.15,6.15,0,0,0-2.85,4.09,1.35,1.35,0,0,1,1.78-.66l.22.13c.05,0,0,.1,0,.09a1.49,1.49,0,0,0-1.59.66,6.63,6.63,0,0,0-.68,1.39c-.07.15-.34.1-.3-.08h0c-.27-2.17,1.15-5.32,3.42-5.69Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M347.88,154.69a9.07,9.07,0,0,0,1-.24,1.62,1.62,0,0,0,.94-.44.52.52,0,0,0,0-.63,1.31,1.31,0,0,0-1.27-.25,1.89,1.89,0,0,0-1.15.71.54.54,0,0,0,.16.76A.45.45,0,0,0,347.88,154.69Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M357.27,155.81a6.85,6.85,0,0,1-1-.16,1.57,1.57,0,0,1-1-.37.5.5,0,0,1,0-.63,1.28,1.28,0,0,1,1.25-.34,2,2,0,0,1,1.21.61.57.57,0,0,1-.1.78A.49.49,0,0,1,357.27,155.81Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M355.38,158.76s.07,0,.07.09c0,1,.13,2.12,1,2.43m0,.06c-1.07-.14-1.28-1.64-1.07-2.58Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M356.21,157.72c1.59-.15,1.77,3,.3,3.17S354.88,157.84,356.21,157.72Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M356.85,157.85c.29.17.58.47.92.49s.66-.34.9-.67h.05c0,.61-.16,1.25-.8,1.38s-1-.4-1.24-1C356.65,158,356.74,157.79,356.85,157.85Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M349.87,158.81s-.08.05-.07.09c.09,1,0,2.13-.84,2.51h0C350.05,161.24,350.11,159.73,349.87,158.81Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M348.92,157.84c-1.59,0-1.51,3.16,0,3.18S350.26,157.86,348.92,157.84Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M348.27,158.06c-.25.18-.49.49-.79.52s-.63-.31-.86-.64h-.05c0,.61.22,1.24.82,1.34s.91-.44,1-1.05C348.46,158.16,348.38,158,348.27,158.06Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M356.61,166.81c-.22.26-.42.6-.78.66a2.66,2.66,0,0,1-1.08-.14m0,.06a1.33,1.33,0,0,0,1.29.4,1,1,0,0,0,.7-.94.09.09,0,0,0-.13,0Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M351.52,163.17s-.14,1.44-.14,2.17a15,15,0,0,1,4,.42c.31.09.29-.17-.06-.36a6,6,0,0,0-3.41-.69c-.05-.19.26-2.27.15-2.27a6,6,0,0,0-1.56.42c.2-3.09.9-6.14,1.05-9.22a.09.09,0,0,0-.18,0,50,50,0,0,0-1.56,9.87C349.84,163.88,351.25,163.3,351.52,163.17Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M353,165.34a3.87,3.87,0,0,0,2,1.37c1.21.12,1.29-1-.06-1.52A3.76,3.76,0,0,0,353,165.34Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M355,166.71a2.52,2.52,0,0,1-1.23-.59c.22-.39.78-.83,2.1-.2C356.11,166.39,355.8,166.79,355,166.71Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M368.11,176c1.76,0,4.72.44,8.73,3.48,0,0-8.35,6.72-16.12,6.72-2.77,0-3.6-3.88-3.6-3.88S360.85,176.09,368.11,176Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M500,464.26H467.29c-23.76,0-38.3-16.43-40.91-46.25-1.29-14.71-2.08-32.51-2.91-51.35-2.57-57.89-6.08-137.15-28.61-137.15H369v-6h25.9c28.27,0,31.49,72.65,34.6,142.9.83,18.78,1.63,36.52,2.91,51.06,1.63,18.6,9,40.77,34.92,40.77H500Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "387.98 187.74 386.7 193.75 368.96 193.75 368.96 187.74 387.98 187.74"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 309.67,
    y: 154.8,
    width: 10.47,
    height: 73.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 269.87,
    y: 160.2,
    width: 39.81,
    height: 61.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "309.67 160.21 309.67 221.82 299.78 221.82 295.35 160.21 309.67 160.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239.32,207h30.54v9.21H239.32a4,4,0,0,1-3.95-3.95h0V211a3.94,3.94,0,0,1,3.94-4Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 259.14,
    y: 171.27,
    width: 10.72,
    height: 9.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239.32,237.29h30.54v9.21H239.32a3.94,3.94,0,0,1-3.95-3.94h0v-1.31a4,4,0,0,1,3.94-4Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 259.14,
    y: 201.55,
    width: 10.72,
    height: 9.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 350.92,
    y: 185.13,
    width: 31.1,
    height: 12.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 350.92,
    y: 185.14,
    width: 31.1,
    height: 12.28
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "361.84 185.14 360.82 197.42 350.92 197.42 350.92 185.14 361.84 185.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M320.15,198.27h24.61a6.16,6.16,0,0,1,6.16,6.16v44.65a6.16,6.16,0,0,1-6.16,6.16H320.15v-57Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "333.24 162.53 328.81 219.5 320.16 219.5 320.16 162.53 333.24 162.53"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.99,
    y: 174.04,
    width: 1.96,
    height: 33.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.55,
    y: 174.04,
    width: 1.96,
    height: 33.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.12,
    y: 174.04,
    width: 1.96,
    height: 33.94
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M379.14,186.51c3.44,9.66-1.49,45.05-7.33,52.54-8.67,11.12-25.8,21.34-32.34,24.53-2.87,1.39-15.69-19.11-12.9-21,6-4.12,25.14-13.94,26.76-15.89s10.35-20.7,13.85-31.24C371.87,181.27,377.41,181.63,379.14,186.51Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.45,263.64c-9.08,5.19-27.15,4.42-29.62,3.67l-3.18-1c-3.79-1.07-4.81-3.16-4.81-3.16s-4.75.06-5.27-2.8c-.58-3.22,6.2-2.68,10.11-4.66,9-4.53,20.44-13.5,22.9-15.06Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M319.42,257.55a62.26,62.26,0,0,1-8.07,3.54,67.72,67.72,0,0,1-9.44,2,.07.07,0,0,0-.05.1.08.08,0,0,0,.05.05,34.23,34.23,0,0,0,17.63-5.45C319.67,257.71,319.56,257.49,319.42,257.55Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M323,262.57c-2.66,1.1-7.36,3-16.31,3.66v.06a30.66,30.66,0,0,0,16.41-3.45C323.21,262.72,323.13,262.5,323,262.57Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M317.14,249.55c.93-1,.38-1.54-2.08-1.1s-11.82,4.31-12.89.93,12.22-8.63,16.37-9.07a69.42,69.42,0,0,1,11.26.34C327.41,242.19,321.77,246.47,317.14,249.55Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369.48,188.94c6.06-12.74,11.58-9.37,12.11,3.23a199.47,199.47,0,0,1-1.18,26.21l-22-6.29Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M374.94,181.51a9.09,9.09,0,0,1,3,3A8.91,8.91,0,0,1,374.94,181.51Zm-8.69,16.14a7.46,7.46,0,0,0,.25,2.1,8.27,8.27,0,0,0,.25-2.1,8.14,8.14,0,0,0-.25-2.09A7.72,7.72,0,0,0,366.25,197.65Zm11.33,2.47a8.68,8.68,0,0,0-2.1.25,8.77,8.77,0,0,0,4.2,0,8.29,8.29,0,0,0-2.1-.27Zm-13.29,10.25a8.11,8.11,0,0,0,1.67,1.31,9.09,9.09,0,0,0-3-3A8.11,8.11,0,0,0,364.29,210.37Zm15.56,1.48a7.8,7.8,0,0,0,1.31-1.66,9.09,9.09,0,0,0-3,3A7.84,7.84,0,0,0,379.85,211.85Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M367.4,192.82c-.82,1.68-1.69,3.32-2.55,5q.22-1.17.36-2.37m-.06,0c-.12.62-.27,1.24-.39,1.86-.05.3-.11.6-.17.9v.19c-.67,1.28-1.33,2.57-2,3.87-.76,1.57-1.47,3.14-2.19,4.71s-1.39,3.49-2.2,5.08a10.58,10.58,0,0,0,2.14.65c.19.07.29-.13.09-.16s-1.84-.68-1.86-.69c.72-1.59,1.61-3.09,2.37-4.65s1.54-3.1,2.27-4.68c1.48-3.18,2.79-6.45,4.26-9.65,0-.08-.07-.11-.07-.07Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M382.5,200.41c-.2.65-.43,1.3-.6,2-.06.28-.13.55-.2.83.08-2.28.16-4.55.22-6.82h0c-.31,3.72-.63,7.44-.87,11.16a104,104,0,0,0-.49,10.73,13.62,13.62,0,0,0-2-.31,9.5,9.5,0,0,0,2.27.65c.55-3.6.59-7.59.77-11.21,0-1,.08-2,.12-3.07.12-.63.3-1.26.47-1.88s.3-1.34.44-2C382.58,200.39,382.51,200.37,382.5,200.41Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M379.52,215.06c-3.09-1.1-15.91-5.15-18.73-5.84-.2-.05-.28.06-.08.13a177.72,177.72,0,0,0,18.76,5.82C379.55,215.2,379.6,215.08,379.52,215.06Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M271.89,211.66c3,.92,2.4-3.18,2.4-3.18s2.35,5.69,5.84,5.44,2.42-5.19,2.36-5.55c.12.3,2.42,5.47,5.9,4.86s1.81-5.44,1.69-5.74c.21.24,3,3.43,5.57,2.36,4.36-1.84-2.6-10.21-2.09-14l6.13.18a5.4,5.4,0,0,0,.6-.09l.23-3.14a38.88,38.88,0,0,1-5.66-2.84c-2.31-1.3-4.55-2.48-6.21-2.52a3.47,3.47,0,0,0-3.45,2.29s-1.8-2.84-4.57-2.44c-1.41.21-2.33,2.66-2.33,2.66a4.15,4.15,0,0,0-4-1.71c-1.95.4-2.57,2.8-2.57,2.8s-2.46-1.45-4.31-.39C263.7,192.7,265.41,209.66,271.89,211.66Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.32,195.48l5.34.49a5.4,5.4,0,0,0,.6-.09c6.75-1.22,11-8.95,6-9.5-3.71-.43-7.74,4.5-11.49,3.51h0Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M271.51,191.34a29.45,29.45,0,0,0,2.79,17.32c.09.17.4.09.34-.11a60,60,0,0,1-3-17.21Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M278.3,189.81c0-.07-.11-.07-.12,0a27.64,27.64,0,0,0,4.12,18.71c.14.19.45.23.31,0C280.38,204.66,278.3,195.31,278.3,189.81Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M290.48,207.73c-3.45-5.45-4.82-11.45-5.33-17.82,0-.08-.12-.06-.14,0-.59,3.18.16,7.21,1,10.29a17,17,0,0,0,4.27,7.64C290.38,207.93,290.56,207.85,290.48,207.73Z",
    transform: "translate(0 -35.74)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M205.92,435.91c-2.07.69-61.4.52-63.67-.91-.85-.55-1.33-9.19-1.61-19.66-.07-2.25-.11-4.58-.15-6.95,0-2.81-.08-5.65-.1-8.41-.07-12.4.1-23.31.1-23.31h38.63v31.72l-.2,6.95s22.69,10.23,25,12.08S208,435.27,205.92,435.91Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.92,435.91c-2.07.69-61.4.52-63.67-.91-.85-.55-1.33-9.19-1.61-19.66-.07-2.25-.11-4.58-.15-6.95,0-2.81-.08-5.65-.1-8.41H179.1v8.41l-.2,6.95s22.69,10.23,25,12.08S208,435.27,205.92,435.91Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M206.1,436c-1.35.45-26.62.54-45,.16-4.26-.1-8.15-.21-11.29-.35-4.33-.2-7.24-.43-7.71-.73-1.05-.68-1.54-13.37-1.78-26.76h38.81l-.2,7s22.82,10.3,25.14,12.15S208.22,435.34,206.1,436Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M205.22,433.65c-10-.28-50.35-.44-60.26.05-.08,0-.08.05,0,.06,9.91.49,50.26.32,60.26.05C205.46,433.8,205.47,433.65,205.22,433.65Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.33,413.14c-3.93-.74-8.74-.15-11.76,2.64-.12.11,0,.27.17.23a55.26,55.26,0,0,1,11.58-2.37.25.25,0,0,0,.26-.24.26.26,0,0,0-.25-.26Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.2,414.88c-3.94-.75-8.75-.16-11.77,2.65-.11.1,0,.27.17.23a54.74,54.74,0,0,1,11.6-2.4.24.24,0,0,0,.17-.31A.29.29,0,0,0,183.2,414.88Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M186,416.59c-3.93-.76-8.75-.16-11.76,2.63-.12.11,0,.28.16.24A55.79,55.79,0,0,1,186,417.08a.26.26,0,0,0,.21-.29A.25.25,0,0,0,186,416.59Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M188.84,418.31c-3.93-.75-8.75-.16-11.76,2.63-.12.11,0,.28.17.24a54.43,54.43,0,0,1,11.57-2.38.25.25,0,0,0,.21-.29A.23.23,0,0,0,188.84,418.31Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M187.63,404.06c-1.54-2.13-4.42-1.18-6.06.19a21,21,0,0,0-6.09,9,.1.1,0,0,0,.05.13h0c0,.3.28.62.61.49,3.25-1.19,6.89-2.06,9.67-4.22C187.48,408.41,189.09,406.08,187.63,404.06Zm-6.88,7c-1.59.62-3.2,1.17-4.76,1.85a62.69,62.69,0,0,1,3.67-5.17,22.37,22.37,0,0,1,2.1-2.25c1.17-1.07,5.81-3.32,5.1,1-.39,2.38-4.22,3.82-6.11,4.57Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M165.48,412.19c3.23,1.39,7,1.33,10.41,1.68a.5.5,0,0,0,.5-.5.59.59,0,0,0,0-.13.11.11,0,0,0,0-.14l0,0a21.06,21.06,0,0,0-8.09-7.21c-1.94-.92-5-1.12-5.92,1.34S163.59,411.38,165.48,412.19Zm-1.77-2.8c-1.77-4,3.29-3,4.69-2.25A21.9,21.9,0,0,1,171,408.8a59.24,59.24,0,0,1,4.85,4.09c-1.68-.27-3.37-.4-5.07-.61C168.75,412,164.68,411.59,163.71,409.39Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M184.61,405.63l-47.87.86s-6.52-42.35-10.8-68.69c-1.63-9.9-2.91-17.55-3.43-19.85-1.24-5.5-25.5-92.73-25.5-92.73l34.8-.05h11.9s-.77,14.58-.32,16.12c6.21,21.11,18.9,58.55,22.86,71.59C172.33,332.93,184.61,405.63,184.61,405.63Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.25,398.3c-6.86-.05-31.23-.32-40.38.53a.08.08,0,0,0,0,.09l0,0c3.15.45,33.52-.25,40.39-.47a.11.11,0,0,0,.13-.08.11.11,0,0,0-.07-.12Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.52,362.2Q135,345.76,132,329.42c-1-5.35-2.09-10.7-3.49-16s-3.18-10.57-5-15.78q-5.37-15.56-10.22-31.29t-9-31.64c-.36-1.34-.71-2.68-1.1-4,0-.11-.19-.06-.17,0,1.09,5.35,2.5,10.65,3.86,15.93s2.8,10.55,4.31,15.8q4.56,15.79,9.9,31.37c1.77,5.17,3.61,10.32,5.19,15.56s2.79,10.54,3.88,15.89c2.21,10.85,4.09,21.77,5.84,32.69s3.23,22,4.69,33c.19,1.39.37,2.79.55,4.19.05.39.67.39.63,0C140.7,384.17,139.15,373.17,137.52,362.2Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M131.81,225.15,125.94,337.8c-1.63-9.9-2.91-17.55-3.43-19.85-1.24-5.5-25.5-92.73-25.5-92.73Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M146.55,445.4c-2.07.69-61.41.52-63.67-.92-.85-.54-1.33-9.18-1.61-19.65-.07-2.26-.11-4.58-.15-6.95,0-2.82-.08-5.65-.1-8.41-.07-12.4.1-23.31.1-23.31h38.62v31.73l-.2,6.95s22.68,10.24,25,12.08S148.62,444.72,146.55,445.4Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.55,445.4c-2.07.69-61.41.52-63.67-.92-.85-.54-1.33-9.18-1.61-19.65-.07-2.26-.11-4.58-.15-6.95,0-2.82-.08-5.65-.1-8.41h38.71v8.42l-.2,6.95s22.68,10.24,25,12.08S148.62,444.72,146.55,445.4Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M146.73,445.49c-1.35.44-26.63.53-45,.15-4.25-.09-8.15-.21-11.29-.34-4.33-.2-7.23-.44-7.71-.74-1-.68-1.54-13.36-1.77-26.75h38.81l-.2,7s22.83,10.29,25.16,12.1S148.81,444.79,146.73,445.49Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M145.88,443.09c-10-.27-50.37-.44-60.27.05-.08,0-.08.06,0,.07,9.9.48,50.27.32,60.27.05C146.09,443.25,146.09,443.1,145.88,443.09Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121,422.59c-3.93-.75-8.75-.16-11.76,2.63-.12.11,0,.28.16.24a55.79,55.79,0,0,1,11.58-2.38.25.25,0,0,0,.21-.28A.27.27,0,0,0,121,422.59Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123.79,424.31c-3.93-.75-8.75-.16-11.76,2.64-.12.11,0,.28.17.24a55.16,55.16,0,0,1,11.58-2.39.25.25,0,0,0,.21-.29A.27.27,0,0,0,123.79,424.31Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126.64,426c-3.94-.75-8.75-.15-11.78,2.64-.11.11,0,.27.17.23a55.22,55.22,0,0,1,11.59-2.37.27.27,0,0,0,.26-.24A.25.25,0,0,0,126.64,426Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M129.47,427.75c-3.93-.74-8.75-.15-11.76,2.64-.12.11,0,.27.16.23a55.77,55.77,0,0,1,11.58-2.37.25.25,0,0,0,.26-.24.24.24,0,0,0-.24-.26Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128.26,413.51c-1.54-2.14-4.43-1.19-6.08.19a21.06,21.06,0,0,0-6.08,9,.11.11,0,0,0,.07.14h0a.47.47,0,0,0,.45.51.47.47,0,0,0,.16,0c3.25-1.19,6.87-2.06,9.67-4.22C128.14,417.89,129.71,415.52,128.26,413.51Zm-6.89,7c-1.59.63-3.19,1.17-4.75,1.86,1.19-1.75,2.3-3.54,3.66-5.17a24.86,24.86,0,0,1,2.09-2.26c1.18-1.06,5.82-3.31,5.12,1-.35,2.38-4.23,3.82-6.12,4.56Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.11,421.64c3.25,1.39,7,1.33,10.43,1.68a.48.48,0,0,0,.49-.48.78.78,0,0,0,0-.16.12.12,0,0,0,.07-.14v0a21.22,21.22,0,0,0-8.14-7.19c-1.94-.92-5-1.12-5.93,1.34S104.2,420.83,106.11,421.64Zm-1.76-2.81c-1.76-4,3.3-3,4.7-2.24a22.67,22.67,0,0,1,2.59,1.65,62.94,62.94,0,0,1,4.85,4.1c-1.7-.28-3.39-.4-5.08-.61-2-.25-6.11-.69-7.08-2.9Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M125.14,414.51H78.29s10.19-145.23,8.54-153.37c-2.69-13.33-.9-28.63,5.41-36h41.67s.84,11.69-3.47,18.68c0,0-3.91,2.47-5.81,3.56Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M120.77,406.93c-6.49-.16-4.61-.21-11.11-.3-3.17-.05-24-.34-27,.13-.07,0-.07.12,0,.13,3,.52,23.84.45,27,.43,6.49,0,4.62-.09,11.11-.19a.1.1,0,0,0,.06-.13A.11.11,0,0,0,120.77,406.93Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M133,242a79.86,79.86,0,0,0-11.72,6.93.14.14,0,0,0,0,.19.13.13,0,0,0,.18,0c4-2.19,8-4.31,11.85-6.71a.25.25,0,0,0,.09-.36A.25.25,0,0,0,133,242Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.73,241.35a18.65,18.65,0,0,0-.56,2.46,5.18,5.18,0,0,0-.13,2c0,.13.21.12.27,0a7.08,7.08,0,0,0,.64-2c.2-.77.42-1.53.59-2.3C128.66,241,127.89,240.85,127.73,241.35Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.36,237.33c.11-.7.22-1.39.35-2.08s.31-1.44.38-2.16c0-.12.2-.08.18,0-.11.7-.12,1.42-.18,2.12s-.12,1.41-.19,2.11c-.14,1.32-.35,2.64-.62,3.94a4.77,4.77,0,0,0,1.92-.79,3.73,3.73,0,0,0,1-2c.2-.8.38-1.6.59-2.4a15.29,15.29,0,0,0,.61-2.66c0-.12.2-.08.18,0a28.19,28.19,0,0,1-1.06,5.61,3.12,3.12,0,0,1-1.05,1.87,6.16,6.16,0,0,1-2.33.69c-.09,0-.23,0-.22-.11A40.71,40.71,0,0,1,127.36,237.33Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.6,260.61c-.3-3.07-.8-6.11-1.13-9.17a57.08,57.08,0,0,1,1.1-18.34c0-.11-.15-.16-.17,0a68,68,0,0,0-1.64,16.09c.27,5.41,1.23,10.74,1.31,16.15s-.34,11-.69,16.43-.71,11-1.06,16.51c-1.42,22.11-2.73,44.23-4.09,66.35q-.56,9.25-1.08,18.52c-.36,6.28-.8,12.56-1,18.86,0,.54.78.5.83,0,.94-11.1,1.48-22.24,2.2-33.35s1.34-22,2-33,1.33-22,2-33q.48-8.25,1-16.5c.32-5.47.72-11,.8-16.44A77.92,77.92,0,0,0,93.6,260.61Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M108.36,232.69a.11.11,0,0,0-.14,0s0,0,0,0a7.14,7.14,0,0,0-.39,2.25,16.68,16.68,0,0,1-.57,2.42,9.76,9.76,0,0,1-2.51,4.21c-2.62,2.45-6.13,3.36-9.52,4.18a.11.11,0,0,0-.07.14.12.12,0,0,0,.07.07,15.07,15.07,0,0,0,5.91-.92,12.27,12.27,0,0,0,4.55-2.55,8.54,8.54,0,0,0,2.47-4.46,14.38,14.38,0,0,0,.28-2.7V234A3.55,3.55,0,0,0,108.36,232.69Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M128,176.51c.86,6.8,14.19,32.11,28.39,43.32,5.2,4.12,32.8,6.55,39.71,6,8.08-.62,9.29-19.85,4.77-21.35-5.66-1.88-31.83-4.19-37-6-6.25-2.26-17.62-16.79-28.43-25.78C129.9,168.05,127.32,171.27,128,176.51Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M196.08,225.85c2.55-.07,14.24-1.41,17.41-2.51s12-4.93,11.45-7.44-3.28-1.6-3.28-1.6,3.49-2.22,2.66-4.69-5-.91-5-.91,3.42-2.53,2.41-4.94-4.91-.14-4.91-.14,3.25-2.18,1.59-3.82c-2-2-7.53,2.71-11.12,3.67-.82.22-16.83,3.21-16.83,3.21Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.23,203.43c-4.07,3.42-6.44,4.22-11.63,4.93a.1.1,0,0,0,0,.12.12.12,0,0,0,0,.05c5.14-.24,8.26-.81,11.8-4.91C217.55,203.42,217.39,203.26,217.23,203.43Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M219.67,208.42c-4.54,3.24-7.1,4.07-12.45,5.25-.07,0-.05.15,0,.14,5.37-.69,8.47-1.34,12.59-5.12C220,208.5,219.88,208.27,219.67,208.42Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M221.38,214.35c-4.62,2.77-7.39,3.86-12.75,4.31a.1.1,0,0,0-.1.1.09.09,0,0,0,.1.1,17.87,17.87,0,0,0,12.81-4.36C221.71,214.29,221.67,214.18,221.38,214.35Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M186.75,204.58a65.19,65.19,0,0,1,8.44-4.62c2.82-1,14.74-1,14.87,1.58.18,3.33-6.7,4.66-10.15,4.88,0,0,.43,7.68-4.31,9.71S186.75,204.58,186.75,204.58Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M209.82,202.47c-2,3.15-6.58,3.14-9.91,3.6a.3.3,0,0,0-.29.31.28.28,0,0,0,0,.13c0,3.23-1,7.78-3.86,9.69-.09.06,0,.19.07.14,3.32-1.64,4.66-6,4.47-9.58,3.42-.41,8-.6,9.51-4.28C209.86,202.46,209.83,202.45,209.82,202.47Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M172.24,225.48s-14.14-3.87-15.86-5.22a61.89,61.89,0,0,1-5.37-4.74c-12.86-12.65-20.63-29.88-22.73-35.89-2.22-6.4-.18-12.52,5.77-8.4a16.26,16.26,0,0,1,1.39,1.09c7,6.11,25.74,24.68,28,25.63s13.28,2.39,13.28,2.39Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M151,215.52c-12.86-12.65-20.63-29.88-22.73-35.89-2.22-6.4-.18-12.52,5.77-8.4Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M172.19,199.9a52.05,52.05,0,0,0-1.64,5.9c-.49,2-1,4-1.41,6a106.46,106.46,0,0,0-2,11.91.09.09,0,0,0,.18,0c1.08-3.93,1.88-7.94,2.7-11.93.41-2,.78-3.94,1.19-5.9s.91-4,1.13-5.95a.09.09,0,0,0-.06-.09A.07.07,0,0,0,172.19,199.9Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.69,190.37c.33,1.48.59,3,.79,4.57v-.18c.08-.86.14-1.73.29-2.57,0,0,.08-.05.08,0a12.55,12.55,0,0,1-.1,2.6c-.05.41-.1.82-.16,1.22.07.69.13,1.38.17,2.06.08,1.3.33,6.86.3,7.81,0,.2-.23.22-.28,0-.19-1-.69-6.7-.83-8a70.06,70.06,0,0,1-.38-7.53S141.67,190.32,141.69,190.37Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M143.28,232c-2,1.8-4.44,4.43-18.5,5.41-.88,0-1.78.07-2.68,0-13.53-.38-32.52-11-33.65-11.85,0,0,14.58-39.46,33.87-54.61,2.76-2.17,8.66-1.1,12.36,1.13,1.32.8,5.68,8.1,6.56,14.75S145.28,230.15,143.28,232Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M132.32,181.93c-3.4.28-8.28-5.6-9.88-10-.11-.3.77-3.17,1.67-6.72.54-2.15,1.1-4.55,1.44-6.78.07-.46,1.5.62,1.5.62l2.78,1.14L139,164a35.66,35.66,0,0,0-2.67,8.37,4.92,4.92,0,0,0,0,.94v.15C136.34,175.19,135.61,181.63,132.32,181.93Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136.33,173.26v.15a7.75,7.75,0,0,1-1.45-.14c-9.41-1.65-8.74-13.83-8.74-13.83l3.7.73,9.21,3.78a35.66,35.66,0,0,0-2.67,8.37A4.24,4.24,0,0,0,136.33,173.26Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M124.59,143.75c-1.79,4.95.12,19.58,3.53,23,4.93,5,13.39,5.83,17.69-.19,4.17-5.83,1.34-24.87-2.5-28C137.66,133.92,127.24,136.45,124.59,143.75Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.93,153.88s-.07.06-.06.1c.15,1,.17,2.13-.69,2.57v0C138.27,156.31,138.24,154.78,137.93,153.88Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136.92,153c-1.6.08-1.32,3.27.16,3.2S138.26,152.89,136.92,153Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M144,153.22a.08.08,0,0,1,.08.08c.06,1,.29,2.12,1.21,2.38h0C144.16,155.67,143.89,154.17,144,153.22Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M144.8,152.11c1.58-.25,2,2.93.51,3.17S143.46,152.33,144.8,152.11Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M135.68,150.6c.42-.15.79-.36,1.2-.55a2.14,2.14,0,0,0,1.11-.78.66.66,0,0,0-.17-.81,1.69,1.69,0,0,0-1.71,0,2.37,2.37,0,0,0-1.32,1.19.71.71,0,0,0,.4.93A.75.75,0,0,0,135.68,150.6Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M145.8,151a11.38,11.38,0,0,1-1.3-.22,2.25,2.25,0,0,1-1.29-.48.69.69,0,0,1,0-.82,1.64,1.64,0,0,1,1.65-.46,2.46,2.46,0,0,1,1.59.81.73.73,0,0,1-.65,1.17Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.86,162.82c.25.21.52.51.88.51a2.58,2.58,0,0,0,1-.34m0,0a1.35,1.35,0,0,1-1.21.64,1.06,1.06,0,0,1-.86-.8.1.1,0,0,1,.14-.06Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M142.6,158.61a19.65,19.65,0,0,1,.19,2.17,14.63,14.63,0,0,0-4,.56c-.3.1-.3-.16,0-.36a5.82,5.82,0,0,1,3.38-.81,19,19,0,0,1-.23-2.27,6.16,6.16,0,0,1,1.58.37c-.32-3.09-1.12-6.1-1.39-9.17,0-.11.15-.15.18,0a49.74,49.74,0,0,1,1.92,9.82C144.32,159.26,142.88,158.72,142.6,158.61Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M125.66,156c2.52-.18,2.2-6.34,2.2-6.34s3.84-.74,5.65-6c0,0,5,3,9.14,2.24,6.49-1.26,6.21-9.72,3.76-11.41-3.49-2.4-9.59,1.23-9.59,1.23s-9.33-2.47-12,3.86a4.77,4.77,0,0,0-4.38,4.81C120.18,148.89,123.78,156.08,125.66,156Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127,150.35a8.57,8.57,0,0,0,4.82-2.73,6.32,6.32,0,0,0,1.41-5.7.1.1,0,0,1,.12-.06s.05,0,.05.06a7.34,7.34,0,0,1-1,6.19,6,6,0,0,1-5.42,2.46C126.89,150.52,126.86,150.37,127,150.35Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M120.05,141.59c1.26-1.64,3.21-1.91,5.15-1.87.11,0,.11.18,0,.17a5.37,5.37,0,0,0-4.79,2.67c-1,1.54-.71,3.45-.3,5.13a13.55,13.55,0,0,0,5.5,8m0,.07a13.45,13.45,0,0,1-6.17-8.74c-.39-1.76-.55-3.9.61-5.44Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136.57,135.94a6.37,6.37,0,0,1,3.54-2.78,7.61,7.61,0,0,1,5.41.48,4.29,4.29,0,0,1,2.3,3.63,7.62,7.62,0,0,1-1.65,4.83h-.06a7.53,7.53,0,0,0,1.27-4.39,3.93,3.93,0,0,0-2.36-3.46c-2.69-1.15-6.59-.91-8.31,1.82C136.66,136.13,136.51,136,136.57,135.94Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M127.14,155.72s-3.14-4.79-5.31-3.68.1,8,2.57,9a2.55,2.55,0,0,0,3.41-1.17.36.36,0,0,1,0-.09Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.48,154v.07a6.45,6.45,0,0,1,3.2,4.13,1.4,1.4,0,0,0-1.9-.58l-.2.13v.09a1.56,1.56,0,0,1,1.71.6,7.53,7.53,0,0,1,.78,1.42c.08.16.36.08.31-.1h0C126.52,157.48,124.87,154.29,122.48,154Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M32.71,464.26H0v-6H32.71c25.9,0,33.29-22.17,34.92-40.77,1.28-14.57,2.07-32.31,2.9-51.06,3.11-70.25,6.33-142.9,34.6-142.9H131v6H105.11c-22.52,0-26,79.28-28.6,137.15-.84,18.85-1.63,36.65-2.91,51.36C71,447.83,56.47,464.26,32.71,464.26Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "131.04 187.74 131.04 193.75 110.38 193.75 109.1 187.74 131.04 187.74"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 220.92,
    y: 152.49,
    width: 11.03,
    height: 77.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 178.99,
    y: 156.14,
    width: 41.93,
    height: 68.95
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "220.92 156.14 220.92 225.09 210.51 225.09 205.83 156.14 220.92 156.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 115.48,
    y: 184.6,
    width: 31.1,
    height: 12.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 115.48,
    y: 184.61,
    width: 31.1,
    height: 12.28
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "135.67 196.88 136.69 184.61 146.59 184.61 146.59 196.88 135.67 196.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M179,256.75H152.74a6.15,6.15,0,0,1-6.15-6.15V202.9a6.15,6.15,0,0,1,6.15-6.15H179v60Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "165.2 221.01 169.87 161.01 178.99 161.01 178.99 221.01 165.2 221.01"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.61,
    y: 173.14,
    width: 2.07,
    height: 35.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.75,
    y: 173.14,
    width: 2.07,
    height: 35.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.89,
    y: 173.14,
    width: 2.07,
    height: 35.74
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M113.57,184.78c-1,14.46-2.14,43.9,4.25,52.54,8.38,11.33,32,18.21,39,20.27,3,.89,10.2-19,8.42-21.88s-26.2-9-28.12-10.69-8-25.15-10.9-37.1C122.51,172.84,114,179.08,113.57,184.78Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M183.32,243.36c3.85.92,9.7-1.06,9.89,1.89.17,2.62-4,3.59-4,3.59s5.07.43,4.45,3.31-5.43,3-5.43,3,4.65.63,3.82,3.45-5.29,3.22-5.29,3.22,1.17.87-.31,2.6c-2.11,2.48-9.16,2.19-12.79,1.17s-16.22-7.47-18.13-8.5l6.37-23.42s7.32-1.16,11.11-1.3,16.36,2.86,15.83,6-9.39.9-11.68.82-2.69.43-1.69,1.28C176.11,241.06,181.61,243,183.32,243.36Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M189,248.79c-5.91,1-8.68.34-14.1-2-.11,0-.2.1-.09.16,5.1,2.76,8.46,4,14.25,2.11C189.32,249,189.26,248.75,189,248.79Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M188.45,255.05c-6.23.45-9.23-.18-15.09-2.2-.08,0-.14.11-.06.15,5.59,2.45,9,3.64,15.13,2.37C188.71,255.32,188.74,255,188.45,255.05Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M186.67,261.78c-6.07,0-9.39-.56-14.83-3.25a.12.12,0,0,0-.15.05.1.1,0,0,0,0,.14c5.28,3.29,9.42,4,14.92,3.25C187,261.91,187.05,261.78,186.67,261.78Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M138.39,252.9s-19.09-9.59-22-16.94c-3.61-9.17-5.08-35.91-3.68-49.62s11-12,14,.11c3,11.83,9.78,35.47,10.48,36.58.89,1.43,11.78,4.12,11.78,4.12",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136.48,220c-.33-1.13-.91-3.68-1.24-4.78-.67-2.2-1.35-4.42-2-6.62s-1.37-4.41-2.1-6.61c-.13-.37-.25-.75-.37-1.12.06-.24-.21-3.14-.19-3.85,0-.11-.18-.12-.17,0a15.17,15.17,0,0,1-.07,2.13v.4c-.46-1.44-.92-2.87-1.39-4.27,0-.1-.2-.06-.17,0,.9,3,1.34,4.89,2,7.32s1.34,4.7,2,7,1.43,4.67,2.17,7a42.19,42.19,0,0,0,1.44,4.09C136.8,221.57,136.82,221.15,136.48,220Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M114.94,228c-.39-2.47-.78-5-1.08-7.45-.61-5-1-9.93-1.22-14.93-.13-2.87-.34-5.71-.5-8.56a.11.11,0,0,0-.22,0h0c0,2.54-.09,5.07,0,7.62v1.11l-.12-.52c-.37-1.45-.89-2.88-1.21-4.35a.08.08,0,0,0-.11,0,.07.07,0,0,0,0,.08c.36,1.46.55,3,.89,4.44.18.73.36,1.46.56,2.19l.1.31c.06,1.46.13,2.92.23,4.38a123,123,0,0,0,1.73,15,59.16,59.16,0,0,0,2.62,9.5.08.08,0,0,0,.1.05.12.12,0,0,0,0-.05C116.13,234.32,115.34,230.51,114.94,228Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M145.43,227.14a52.79,52.79,0,0,0-2.81,5.57c-.88,1.88-1.77,3.76-2.6,5.66a110.3,110.3,0,0,0-4.41,11.5.1.1,0,0,0,.09.11.15.15,0,0,0,.09,0c1.86-3.71,3.45-7.56,5.07-11.38.8-1.88,1.57-3.78,2.36-5.66s1.7-3.78,2.31-5.72C145.55,227.12,145.46,227.09,145.43,227.14Z",
    transform: "translate(0 -35.74)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.43,175.33a.5.5,0,0,1-.5-.5V160.75a.5.5,0,0,1,1,0v14.08a.5.5,0,0,1-.5.5Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224.94,182.08a.5.5,0,0,1-.44-.25l-7-12.2a.5.5,0,0,1,.81-.59l.06.09,7,12.2a.49.49,0,0,1-.16.67h0A.4.4,0,0,1,224.94,182.08Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.62,282.51a.48.48,0,0,1-.26-.07.5.5,0,0,1-.14-.68v0l7-12.19a.5.5,0,1,1,.87.5l-7,12.19A.51.51,0,0,1,217.62,282.51Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.11,291.3a.5.5,0,0,1-.5-.5V276.73a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v14.09A.5.5,0,0,1,250.11,291.3Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M282.65,282.67a.52.52,0,0,1-.44-.25l-7-12.19a.5.5,0,1,1,.87-.5l7,12.19a.49.49,0,0,1-.17.67h0A.48.48,0,0,1,282.65,282.67Z",
    transform: "translate(0 -35.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M275.88,182.24a.43.43,0,0,1-.25-.07.49.49,0,0,1-.19-.67h0l7-12.2a.49.49,0,0,1,.69-.11.5.5,0,0,1,.17.61l-7,12.2A.52.52,0,0,1,275.88,182.24Z",
    transform: "translate(0 -35.74)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.87,81.51V36.4h-13L146.9,82.49l6.61,12.79h28.74v17.46h15.62V95.28h12.69V81.51Zm-32.46,0L182.25,61V81.51Z",
    transform: "translate(0 -35.74)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M249.81,113.83a28.6,28.6,0,0,1-16.54-4.72,29.64,29.64,0,0,1-10.52-13.45q-3.63-8.73-3.63-20.87t3.63-20.88a29.64,29.64,0,0,1,10.52-13.45,31.34,31.34,0,0,1,33.08,0,29.57,29.57,0,0,1,10.52,13.45q3.63,8.73,3.63,20.88t-3.63,20.87a29.57,29.57,0,0,1-10.52,13.45A28.58,28.58,0,0,1,249.81,113.83Zm0-14q7.27,0,11.23-6.56t4-18.49q0-12.26-4-18.88T249.81,49.3q-7.26,0-11.22,6.61t-4,18.88q0,11.92,4,18.49T249.81,99.84Z",
    transform: "translate(0 -35.74)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M322.91,112.74v-61l7.26.43-26.24,32-1.74-2.6h49V95.28h-57l-6.62-12.79,38-46.1h13v76.35Z",
    transform: "translate(0 -35.74)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.58,141.28a5.43,5.43,0,0,1-2.51-.55,4.79,4.79,0,0,1-1.79-1.56l.63-.69a4.42,4.42,0,0,0,1.61,1.51,4.59,4.59,0,0,0,2.16.48,3.67,3.67,0,0,0,1.47-.29,2.56,2.56,0,0,0,1-.79,1.78,1.78,0,0,0,.4-1.16,1.57,1.57,0,0,0-.16-.73,1.66,1.66,0,0,0-.45-.58,3.4,3.4,0,0,0-.73-.47,7.52,7.52,0,0,0-1-.39q-.54-.17-1.2-.33a9.24,9.24,0,0,1-1.44-.5,4,4,0,0,1-1.06-.67,2.52,2.52,0,0,1-.65-.88,3.05,3.05,0,0,1-.21-1.17,2.71,2.71,0,0,1,.5-1.59,3.46,3.46,0,0,1,1.38-1.1,4.55,4.55,0,0,1,1.94-.4,4.86,4.86,0,0,1,2.24.46,3.89,3.89,0,0,1,1.47,1.32l-.61.59a3.62,3.62,0,0,0-1.28-1.16,4.17,4.17,0,0,0-3.33-.12,2.58,2.58,0,0,0-1,.8,2.06,2.06,0,0,0-.21,2.05,1.79,1.79,0,0,0,.55.65,3.84,3.84,0,0,0,.88.5,8.28,8.28,0,0,0,1.21.38,12.54,12.54,0,0,1,1.69.52,5.58,5.58,0,0,1,1.27.66,2.76,2.76,0,0,1,.81.87,2.18,2.18,0,0,1,.28,1.13,2.87,2.87,0,0,1-.49,1.66,3.4,3.4,0,0,1-1.38,1.14A4.79,4.79,0,0,1,168.58,141.28Z",
    transform: "translate(0 -35.74)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.29,141.28a4.46,4.46,0,0,1-2.29-.59,4.25,4.25,0,0,1-1.56-1.59,4.67,4.67,0,0,1-.57-2.32,4.49,4.49,0,0,1,.57-2.28,4.13,4.13,0,0,1,1.56-1.57,4.81,4.81,0,0,1,4.58,0,4.08,4.08,0,0,1,1.54,1.57,4.48,4.48,0,0,1,.56,2.28,4.66,4.66,0,0,1-.56,2.32,4.2,4.2,0,0,1-1.54,1.59A4.44,4.44,0,0,1,178.29,141.28Zm0-.79a3.53,3.53,0,0,0,1.84-.48,3.33,3.33,0,0,0,1.26-1.32,4,4,0,0,0,.45-1.91,3.88,3.88,0,0,0-.45-1.89,3.3,3.3,0,0,0-1.26-1.28,3.86,3.86,0,0,0-3.69,0,3.35,3.35,0,0,0-1.27,1.29,3.88,3.88,0,0,0-.46,1.88,4,4,0,0,0,.46,1.91,3.43,3.43,0,0,0,1.27,1.32A3.54,3.54,0,0,0,178.29,140.49Z",
    transform: "translate(0 -35.74)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5,141.11v-8.65h.82l0,2.33-.12-.22a2.9,2.9,0,0,1,1.48-1.9,2.82,2.82,0,0,1,1.34-.32,3.08,3.08,0,0,1,.53,0,1.81,1.81,0,0,1,.42.11l-.23.89a2.85,2.85,0,0,0-.48-.13,3.77,3.77,0,0,0-.44,0,2.37,2.37,0,0,0-1,.23,2.65,2.65,0,0,0-.79.62,2.76,2.76,0,0,0-.49.84,2.66,2.66,0,0,0-.17.91v5.29Z",
    transform: "translate(0 -35.74)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190.15,141.11v-8.65H191l0,2.33-.12-.22a2.9,2.9,0,0,1,1.48-1.9,2.82,2.82,0,0,1,1.34-.32,3.08,3.08,0,0,1,.53,0,1.81,1.81,0,0,1,.42.11l-.23.89a2.85,2.85,0,0,0-.48-.13,3.77,3.77,0,0,0-.44,0,2.37,2.37,0,0,0-1,.23,2.65,2.65,0,0,0-.79.62,2.76,2.76,0,0,0-.49.84,2.66,2.66,0,0,0-.17.91v5.29Z",
    transform: "translate(0 -35.74)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M197.25,144.9l1.63-4,.05.64-4.09-9.11h1L199,139.7a2.71,2.71,0,0,1,.18.41l.12.34-.25.09c.06-.16.13-.31.19-.47s.12-.32.17-.47l2.79-7.14h1l-3.58,8.78-1.43,3.66Z",
    transform: "translate(0 -35.74)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.73,141.11V129.58h4.35a3,3,0,0,1,1.63.43,3.17,3.17,0,0,1,1.1,1.17,3.48,3.48,0,0,1,.4,1.71,4,4,0,0,1-.4,1.83,3.36,3.36,0,0,1-1.1,1.28,2.89,2.89,0,0,1-1.63.47h-3.49v4.64Zm.86-5.48h3.53a1.87,1.87,0,0,0,1.14-.37,2.37,2.37,0,0,0,.79-1,3.24,3.24,0,0,0,.29-1.4,2.7,2.7,0,0,0-.29-1.27,2.24,2.24,0,0,0-.79-.88,2.13,2.13,0,0,0-1.14-.32h-3.53Z",
    transform: "translate(0 -35.74)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M221.54,141.28a3.3,3.3,0,0,1-1.49-.33A2.68,2.68,0,0,1,219,140a2.4,2.4,0,0,1-.39-1.37,2.54,2.54,0,0,1,.22-1.06,2,2,0,0,1,.67-.78,3.5,3.5,0,0,1,1.12-.47,6.66,6.66,0,0,1,1.57-.16h3l-.07.72H222a4.63,4.63,0,0,0-1.12.12,2.44,2.44,0,0,0-.82.34,1.35,1.35,0,0,0-.52.54,1.49,1.49,0,0,0-.18.75,1.64,1.64,0,0,0,.3,1,1.92,1.92,0,0,0,.78.66,2.58,2.58,0,0,0,1.08.23,3.8,3.8,0,0,0,1.41-.26,4,4,0,0,0,1.17-.74,3.55,3.55,0,0,0,.83-1.09l.28.51a4.75,4.75,0,0,1-.94,1.2A4.17,4.17,0,0,1,223,141,3.63,3.63,0,0,1,221.54,141.28Zm3.32-.17v-5.89a1.89,1.89,0,0,0-.67-1.52,2.77,2.77,0,0,0-1.82-.56,3.49,3.49,0,0,0-1.58.36,3.66,3.66,0,0,0-1.27,1.06L219,134a4.33,4.33,0,0,1,3.47-1.65,4.24,4.24,0,0,1,1.71.32,2.31,2.31,0,0,1,1.09,1,2.77,2.77,0,0,1,.38,1.5v6Z",
    transform: "translate(0 -35.74)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M231.66,145a4.85,4.85,0,0,1-1.75-.32,3.55,3.55,0,0,1-1.35-.85l.33-.66a3.66,3.66,0,0,0,1.22.76,4.33,4.33,0,0,0,1.53.28,3.34,3.34,0,0,0,1.67-.42,3.06,3.06,0,0,0,1.17-1.22,3.89,3.89,0,0,0,.44-1.92v-2.09h.17a3.11,3.11,0,0,1-.68,1.37,4,4,0,0,1-1.24,1,3.5,3.5,0,0,1-1.56.36,4.06,4.06,0,0,1-3.67-2.15,5.06,5.06,0,0,1,0-4.61,4.41,4.41,0,0,1,1.5-1.59,4,4,0,0,1,3.11-.44,3.68,3.68,0,0,1,.91.39,3.77,3.77,0,0,1,.78.58,3.52,3.52,0,0,1,.57.73,2.73,2.73,0,0,1,.32.81l-.22,0,0-2.56h.8v8.26a5.07,5.07,0,0,1-.3,1.8,3.77,3.77,0,0,1-.86,1.35,3.81,3.81,0,0,1-1.3.85A4.32,4.32,0,0,1,231.66,145Zm0-4.53a3.09,3.09,0,0,0,1.69-.47,3.4,3.4,0,0,0,1.16-1.3,4.2,4.2,0,0,0,.43-1.91,4.11,4.11,0,0,0-.42-1.89,3.27,3.27,0,0,0-1.17-1.3,3.1,3.1,0,0,0-1.71-.48,3.27,3.27,0,0,0-3,1.79,4,4,0,0,0-.44,1.9,4,4,0,0,0,.44,1.88,3.32,3.32,0,0,0,3,1.78Z",
    transform: "translate(0 -35.74)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M241.94,141.28a4.36,4.36,0,0,1-2.27-.58,4.08,4.08,0,0,1-1.53-1.58,4.7,4.7,0,0,1-.55-2.31,5.15,5.15,0,0,1,.3-1.8,4.43,4.43,0,0,1,.86-1.42,3.65,3.65,0,0,1,1.33-.92,4.42,4.42,0,0,1,1.69-.32,4,4,0,0,1,1.53.29,3.72,3.72,0,0,1,1.22.81,3.59,3.59,0,0,1,.79,1.27,4.37,4.37,0,0,1,.24,1.65l0,.54h-7.36l-.14-.72h6.86l-.2.28v-.41a2.85,2.85,0,0,0-1.46-2.55,2.81,2.81,0,0,0-1.44-.37,3.49,3.49,0,0,0-1.8.45,3.1,3.1,0,0,0-1.16,1.27,4.28,4.28,0,0,0-.4,1.92,4,4,0,0,0,.45,1.94,3.47,3.47,0,0,0,1.25,1.3,3.68,3.68,0,0,0,1.87.47,3.86,3.86,0,0,0,1.45-.27,4,4,0,0,0,1.26-.82l.42.61a4.79,4.79,0,0,1-.9.67,4.6,4.6,0,0,1-1.1.44A4.38,4.38,0,0,1,241.94,141.28Z",
    transform: "translate(0 -35.74)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M252.51,141.11V129.58h.8L260.83,140l-.13.07c0-.28-.06-.59-.08-.94s0-.8,0-1.34,0-1.21,0-2v-6.23h.86v11.53h-.79L253,130.59l.23-.09c0,.39,0,.76.07,1.13s0,.72,0,1.05,0,.64,0,.93v7.5Z",
    transform: "translate(0 -35.74)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M268.25,141.28a4.4,4.4,0,0,1-2.28-.59,4.2,4.2,0,0,1-1.57-1.59,4.67,4.67,0,0,1-.57-2.32,4.49,4.49,0,0,1,.57-2.28,4.08,4.08,0,0,1,1.57-1.57,4.79,4.79,0,0,1,4.57,0,4,4,0,0,1,1.54,1.57,4.48,4.48,0,0,1,.56,2.28,4.66,4.66,0,0,1-.56,2.32,4.13,4.13,0,0,1-1.54,1.59A4.44,4.44,0,0,1,268.25,141.28Zm0-.79a3.53,3.53,0,0,0,1.84-.48,3.33,3.33,0,0,0,1.26-1.32,4,4,0,0,0,.45-1.91,3.88,3.88,0,0,0-.45-1.89,3.3,3.3,0,0,0-1.26-1.28,3.86,3.86,0,0,0-3.69,0,3.35,3.35,0,0,0-1.27,1.29,3.88,3.88,0,0,0-.46,1.88,4,4,0,0,0,.46,1.91A3.43,3.43,0,0,0,266.4,140,3.54,3.54,0,0,0,268.25,140.49Z",
    transform: "translate(0 -35.74)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M273.68,133.27v-.81H279v.81Zm2.16,7.84V130.26h.84v10.85Z",
    transform: "translate(0 -35.74)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M285.63,141.11V129.58h.85v11.53Zm.41-5.37v-.84h5.52v.84Zm0-5.32v-.84h6.38v.84Z",
    transform: "translate(0 -35.74)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M298.33,141.28a4.46,4.46,0,0,1-2.29-.59,4.25,4.25,0,0,1-1.56-1.59,4.67,4.67,0,0,1-.57-2.32,4.49,4.49,0,0,1,.57-2.28,4.13,4.13,0,0,1,1.56-1.57,4.81,4.81,0,0,1,4.58,0,4,4,0,0,1,1.54,1.57,4.48,4.48,0,0,1,.56,2.28,4.66,4.66,0,0,1-.56,2.32,4.13,4.13,0,0,1-1.54,1.59A4.44,4.44,0,0,1,298.33,141.28Zm0-.79a3.53,3.53,0,0,0,1.84-.48,3.33,3.33,0,0,0,1.26-1.32,4,4,0,0,0,.45-1.91,3.88,3.88,0,0,0-.45-1.89,3.3,3.3,0,0,0-1.26-1.28,3.86,3.86,0,0,0-3.69,0,3.35,3.35,0,0,0-1.27,1.29,3.88,3.88,0,0,0-.46,1.88,4,4,0,0,0,.46,1.91,3.43,3.43,0,0,0,1.27,1.32A3.54,3.54,0,0,0,298.33,140.49Z",
    transform: "translate(0 -35.74)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M307.68,141.28a3.42,3.42,0,0,1-1.66-.38,2.45,2.45,0,0,1-1.06-1.14,4.28,4.28,0,0,1-.37-1.91v-5.39h.84v5.21a3.09,3.09,0,0,0,.65,2.15,2.43,2.43,0,0,0,1.87.7,2.35,2.35,0,0,0,1-.22,3.36,3.36,0,0,0,.85-.55,2.59,2.59,0,0,0,.58-.72,1.54,1.54,0,0,0,.21-.72v-5.85h.84v8.65h-.81l0-1.94.19-.08a3,3,0,0,1-.66,1.09,3.35,3.35,0,0,1-1.09.8A3.17,3.17,0,0,1,307.68,141.28Z",
    transform: "translate(0 -35.74)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M313.79,141.11v-8.65h.83l0,1.92-.2.11a2.61,2.61,0,0,1,.66-1.06,3.83,3.83,0,0,1,2.62-1.08,3.45,3.45,0,0,1,1.64.36,2.35,2.35,0,0,1,1,1.12,4.52,4.52,0,0,1,.36,1.93v5.35h-.84v-5.32a3.58,3.58,0,0,0-.28-1.53,1.73,1.73,0,0,0-.8-.86,2.67,2.67,0,0,0-1.31-.26,3.15,3.15,0,0,0-1.16.21,3,3,0,0,0-.91.53,2.7,2.7,0,0,0-.6.69,1.37,1.37,0,0,0-.21.68v5.86h-.85Z",
    transform: "translate(0 -35.74)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M326.69,141.28a4,4,0,0,1-2.14-.58,4.14,4.14,0,0,1-1.48-1.57,4.76,4.76,0,0,1-.54-2.3,4.7,4.7,0,0,1,.55-2.31,4.2,4.2,0,0,1,1.48-1.59,3.81,3.81,0,0,1,2.08-.58,3.56,3.56,0,0,1,1.26.22,4.58,4.58,0,0,1,1.11.6,3.58,3.58,0,0,1,.82.88,2.54,2.54,0,0,1,.39,1l-.23,0v-6.16h.84v12.19H330v-2.55l.2-.05a2.75,2.75,0,0,1-.41,1.08,3.45,3.45,0,0,1-.79.87,3.93,3.93,0,0,1-1.06.6A3.72,3.72,0,0,1,326.69,141.28Zm.07-.76a3.07,3.07,0,0,0,1.67-.47,3.22,3.22,0,0,0,1.16-1.31,4.52,4.52,0,0,0,0-3.85,3.31,3.31,0,0,0-1.16-1.32,3,3,0,0,0-1.69-.48,3.14,3.14,0,0,0-1.75.49,3.36,3.36,0,0,0-1.2,1.33,4.3,4.3,0,0,0-.42,1.92,4.17,4.17,0,0,0,.42,1.89A3.33,3.33,0,0,0,325,140,3.26,3.26,0,0,0,326.76,140.52Z",
    transform: "translate(0 -35.74)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M334,141.26a.7.7,0,0,1-.54-.21,1,1,0,0,1-.19-.61,1,1,0,0,1,.19-.6.68.68,0,0,1,.54-.23.7.7,0,0,1,.55.22.86.86,0,0,1,.19.61.89.89,0,0,1-.2.58A.68.68,0,0,1,334,141.26Zm-.21-4.12c0-.47-.07-.95-.09-1.43s-.05-1-.07-1.47,0-1,0-1.43l0-3.23h.86v3.23c0,.47,0,1,0,1.46s0,1-.07,1.47-.06.95-.1,1.4Z",
    transform: "translate(0 -35.74)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.d96e68fc.svg";
export { ForwardRef as ReactComponent };